import { Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface DatePickerFieldProps {
  label: string;
  value: Date | null;
  onChange: (next: Date | null) => void;
  id?: string;
  disabled?: boolean;
  className?: string;
}

export function DatePickerField({
  label,
  value,
  onChange,
  id,
  disabled = false,
  className,
}: Readonly<DatePickerFieldProps>) {
  const inputId = id ?? `date-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <Label htmlFor={inputId} className="text-muted-foreground text-xs uppercase tracking-wide">
        {label}
      </Label>
      <div className="flex items-center gap-2">
        <Input
          id={inputId}
          type="date"
          aria-label={label}
          value={value === null ? '' : toInputValue(value)}
          disabled={disabled}
          onChange={(event) => {
            const next = event.target.value;
            onChange(next === '' ? null : new Date(`${next}T00:00:00.000Z`));
          }}
          className="text-base sm:text-sm"
        />
        {value !== null && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="text-muted-foreground hover:text-destructive size-10 shrink-0 sm:size-8"
            aria-label={`Clear ${label}`}
            disabled={disabled}
            onClick={() => {
              onChange(null);
            }}
          >
            <Trash2 className="size-4" />
          </Button>
        )}
      </div>
    </div>
  );
}

function toInputValue(value: Date): string {
  return value.toISOString().slice(0, 10);
}
